// @flow
import { App } from './jsti/core';
//
import './bootstrap';
//
import DisableDraggingPlugin from './plugins/DisableDraggingPlugin';
import Store from './classes/Store';
import type { InsiderCampaign, InsiderUnprocessedProduct } from './types/UseInsider';
import { flare } from '@flareapp/flare-client';

class MedPetsApp extends App {
  /**
   *
   */
  static initIE(): void {
    const ua: string = navigator.userAgent.toLowerCase();
    const isIE: boolean = (ua.indexOf('msie') > -1) || ua.indexOf('trident/') > -1;
    const isEdge: boolean = ua.indexOf('edge') > -1;
    const isFirefox: boolean = ua.includes('firefox');
    const html: HTMLHtmlElement | null = document.querySelector('html');
    if (html) {
      if (isIE) {
        html.classList.add('ie11');
      }
      if (isEdge) {
        html.classList.add('ms-edge');
      }
      if (isFirefox) {
        html.classList.add('firefox');
      }
    }
  }

  /**
   *
   */
  static initTouch(): void {
    const ua: string = navigator.userAgent.toLowerCase();
    const isiPhone: boolean = ua.indexOf('iphone') !== -1;
    const isiPad: boolean = ua.indexOf('ipad') !== -1;
    const isiPod: boolean = ua.indexOf('ipod') !== -1;
    const isIOS: boolean = (isiPhone || isiPad || isiPod);
    const isAndroid: boolean = (ua.indexOf('android') > -1);
    const isTouch: boolean = !!('ontouchstart' in window);
    const html: HTMLHtmlElement | null = document.querySelector('html');
    if (html) {
      if (isIOS) {
        html.classList.add('ios');
      }
      if (isiPhone) {
        html.classList.add('iphone');
      }
      if (isiPad) {
        html.classList.add('ipad');
      }
      if (isAndroid) {
        html.classList.add('android');
      }
      if (isTouch) {
        html.classList.add('touch');
      }
    }
  }

  /**
   * Initialize the app
   */
  init(): void {
    window.store = new Store();

    super.init();
    MedPetsApp.initIE();
    MedPetsApp.initTouch();
    new DisableDraggingPlugin().activate();

    setTimeout(() => {
      window.notification = require('./notifications/Notification').default;
    }, 0);

    this.initializeFlare();
    this.initializeInsider();
  }

  /**
   * Initialize UseInsider
   * Note: Contains any types because response can be any of 5 types
   */
  initializeInsider() {
    const ajaxListener = function (callback: any) {
      const originalOpen = XMLHttpRequest.prototype.open;

      XMLHttpRequest.prototype.open = function (method: string, url: string) {
        this.addEventListener('readystatechange', function () {
          if (this.responseType !== 'arraybuffer' && this.responseType !== 'blob' &&
            this.readyState === 4 && this.status === 200 && typeof callback === 'function') {
            callback(url, this.response, method);
          }
        });

        originalOpen.apply(this, arguments);
      };
    };

    ajaxListener(function (url: string, response: any, method: string) {
      if (window.Insider?.initialized && method === 'POST' && url.indexOf('hit.api.useinsider.com/hit') > -1) {
        window.Insider.eventManager.once('ins-sr:only-api-campaign:load', function (event: CustomEvent, data: InsiderCampaign) {
          window.dispatchEvent(new CustomEvent('insiderCampaign', {
            detail: {
              campaignId: data.campaignId,
              variationId: data.variationId,
              products: data.products.map((product: InsiderUnprocessedProduct) => ({
                simpleSku: product.item_id,
                visibleSku: product.groupcode,
                url: product.url
              }))
            }
          }));
        });
      }
    });
  }

  initializeFlare(): void {
    if (!window.store.environment.isLocal()) {
      flare.light();
    }
  }
}

const app = new MedPetsApp();
app.init();

export default MedPetsApp;
